import React from "react";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

import FileItem from "fe-shared/src/components/FileList/FileItem";
import { downloadFile } from "fe-shared/src/helpers/files";
import { getOffsetDate } from "fe-shared/src/helpers/dates";
import {
  DocumentsResponse,
  ScaleTicket,
} from "fe-shared-transactions/src/types";

import styles from "../InventoryAdjustmentsDetails.module.scss";

interface Props {
  attachments: DocumentsResponse[];
  scaleTicket?: ScaleTicket;
  adjustmentDate?: string;
}

const InventoryAdjustmentDetailsGeneralInfoSection = ({
  attachments,
  scaleTicket,
  adjustmentDate,
}: Props) => {
  const { t } = useTranslation();

  return (
    <section>
      <h2 className={styles.sectionTitle}>
        {t("inventoryAdjustment.details.supportingDocuments")}
      </h2>
      <div>
        {attachments.map(({ documentPath, ...rest }) => (
          <FileItem
            disabled
            isViewOnly
            isDownloadActive
            id={documentPath}
            key={documentPath}
            onDownload={(id, fileName) => {
              downloadFile(documentPath, fileName);
            }}
            {...rest}
          />
        ))}
        {!attachments?.length && (
          <span className={styles.emptyState}>
            {t("inventoryAdjustment.details.documents.emptyState")}
          </span>
        )}
      </div>
      {adjustmentDate && (
        <div className={styles.scaleTicketRow}>
          <span>{t("inventoryAdjustment.details.adjustmentDate")}</span>
          <span>
            {t(
              format(getOffsetDate(new Date(adjustmentDate))!, "MMM dd, yyyy")
            )}
          </span>
        </div>
      )}
      {scaleTicket?.ticketNumber && (
        <div className={styles.scaleTicketRow}>
          <span>{t("inventoryAdjustment.details.scaleTicketNumber")}</span>
          <span>{scaleTicket.ticketNumber}</span>
        </div>
      )}
    </section>
  );
};

export default InventoryAdjustmentDetailsGeneralInfoSection;
